// @flow

import React from 'react';

import { ContentLoader } from '@zapier/common-components';

export const Skeleton = () => (
  <ContentLoader height="256px">
    <rect height="256" rx="0" ry="0" width="100%" x="0" y="0" />
  </ContentLoader>
);
